import WorkRecordsTable from "./WorkRecordsTable";
import SitePatrolRecordsTable from "./SitePatrolRecordsTable";
import CommonInstructions from "./CommonInstructions";
import CommonInstructionsPrintFunction from "./CommonInstructionsPrintFunction";
import InspectionsRecordsTable from "./InspectionsRecordsTable";
import AttachedImage from "./AttachedImage";
import CarryingIORecordsTable from "./CarryingIORecordsTable";
import SafetyPlanRecordsTable from "./SafetyPlanRecordsTable";
import SafetyPlanImprovementPlanRecordsTable from "./SafetyPlanImprovementPlanRecordsTable";
import Co2Modal from "./Co2Modal";
import NavBarTop from "../shared/NavBarTop";
import MessModal from "../shared/MessModal";
import SignatureModal from "../shared/SignatureModal";
import moment from "moment";
import { postDiaryApi, getDiariesApi } from "@/api/DiaryApi";
import { getDiaryRevision } from "@/api/DashboardApi";
import { generatePdfFromDiary } from "@/api/PdfApi";
import { generateDiaryPdf } from "@/api/DiaryPdfApi";
import {
  downloadFileFromUrl,
  downloadBlob,
  base64ToBlob,
  sanitizeFileName,
  DownloadError,
} from "@/services/FileDownloadService";
import { buildPdfPayload as buildDiaryPdfPayload } from "@/services/DiaryPdfPayload";
import { isNewPdfButtonVisible } from "@/services/NewPdfButton";
import { getMe } from "@/api/ProfileApi";
import DashboardServices from "@/services/DashboardServices";
import { configDatePick, isInt, isFloat } from "@/services/GlobalServices";
import DashboardConstants from "@/store/constants/dashboardRecords";
import DiaryListConstants from "@/store/constants/diaryListRecords";
import { getMetaDataSite, getSiteUserMe } from "@/api/SiteApi";
import ConfirmModal from "@/components/shared/ConfirmModal";
import PresenceIndicator from "@/components/shared/PresenceIndicator";
import PresenceService from "@/services/PresenceService";
export default {
  name: "Dashboard",
  components: {
    WorkRecordsTable,
    SitePatrolRecordsTable,
    CommonInstructions,
    CommonInstructionsPrintFunction,
    InspectionsRecordsTable,
    AttachedImage,
    CarryingIORecordsTable,
    SafetyPlanRecordsTable,
    SafetyPlanImprovementPlanRecordsTable,
    Co2Modal,
    NavBarTop,
    MessModal,
    SignatureModal,
    ConfirmModal,
    PresenceIndicator,
  },
  data() {
    return {
      meta: {
        // states: ["beforeMeeting", "completedMeeting", "inputCo2Values"],
        states: ["beforeMeeting", "completedMeeting"],
      },
      selectedWorkContent: {},
      workContentAction: null,
      weathers: [
        { name: "Sunny", key: "sunny" },
        { name: "Cloudy", key: "cloudy" },
        { name: "Rainy", key: "rainy" },
        { name: "Temporary Rain", key: "temporaryRainy" },
        { name: "Snowy", key: "snowy" },
        { name: "Temporary Snowy", key: "temporarySnowy" },
      ],
      dataTimePickerOptions: configDatePick("LLLL"),
      meetingDateTimePickerOptions: {
        ...configDatePick("YYYY/MM/DD HH:mm"),
        extraFormats: ["LLLL", "YYYY-MM-DD HH:mm", "YYYY/MM/DD HH:mm:ss"],
      },
      statusSaveDiary: false,
      isPostedDiary: false,
      showEditorError: false,
      typeMess: "",
      isGeneratingPdf: false, // PDF生成中フラグ
      isGeneratingPdfV2: false, // PDF生成中フラグ（新レイアウト・試行中）
      showNewPdfButton: isNewPdfButtonVisible(), // 新レイアウトのボタンを表示するか（issue #995）
      siteUserRole: null, // サイトでのユーザー役割
      activeEditors: [],
      currentUserSub: "",
      showConflictModal: false,
      conflictMessage: "",
      conflictLocalAdditionsCount: 0,
      isMerging: false,
    };
  },
  mounted() {
    // fetch data from API
    const diaryId = this.$route.query.diary;
    const diaryIdPrevious = this.$route.query.diaryPrevious;
    const siteId = this.$route.query.siteId;
    const objDateTemp = moment.unix(this.$route.query.objDate);
    const period = this.$route.query.period;
    const objDate = {
      year: objDateTemp.format("YYYY"),
      month: objDateTemp.format("MM"),
      day: objDateTemp.format("DD"),
    };
    const typeEdit = this.$route.query.typeEdit;

    console.info(`objDate:`, objDate);
    console.info(`diaryId:`, diaryId);
    console.info(`diaryIdPrevious:`, diaryIdPrevious);
    this.$store.dispatch(DashboardConstants.DISPATCH.getDiaryRevisionRecords, {
      siteId: siteId,
      objDate: objDate,
      diaryId: diaryId,
      diaryIdPrevious: diaryIdPrevious,
      typeEdit: typeEdit,
      period: period,
    });
    this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
      path: "diaryPeriod",
      value: period,
    });
    this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
      path: "diaryDate",
      value: objDateTemp,
    });

    // 日付ナビゲーション用に日誌日付一覧を取得
    this.$store.dispatch(DashboardConstants.DISPATCH.fetchDiaryDates, {
      siteId: siteId,
      period: period,
    });

    this.handleBackButton();

    getSiteUserMe(siteId).then(response => {
      this.siteUserRole = response.data.role;
    }).catch(error => {
      console.error('Failed to get site user role:', error);
    });

    // プレゼンス用の日付文字列
    const diaryDateStr = `${objDate.year}-${objDate.month}-${objDate.day}`;
    PresenceService.onEditorsUpdated = (editors) => {
      this.activeEditors = editors;
    };

    // ログインユーザー名を取得して入力者・安全当番にデフォルト設定
    getMe().then((response) => {
      const userName = response.data.name;
      this.currentUserSub = response.data.sub || "";
      if (userName) {
        this.$store.commit("dashboardRecords/setLoggedInUserName", userName);
        if (!this.getDataHeader.meta.editor) {
          this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
            path: "editor",
            value: userName,
          });
        }
        this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
          path: "responsibleOfSafe",
          value: userName,
        });
      }
      PresenceService.start(siteId, diaryDateStr, period, userName);
    }).catch(error => {
      console.error('Failed to get user info:', error);
      PresenceService.start(siteId, diaryDateStr, period, null);
    });

    this._beforeUnloadHandler = () => {
      PresenceService.stop();
    };
    window.addEventListener("beforeunload", this._beforeUnloadHandler);

    // データロード後にサインデータをログ出力
    setTimeout(() => {
      console.log("getSigns:", this.getSigns);
      if (this.getSigns && this.getSigns.length > 0) {
        this.getSigns.forEach((sign, index) => {
          console.log(`Sign ${index}:`, sign);
          console.log(`  - name:`, sign.sign.name);
          console.log(`  - jobTitle:`, sign.sign.jobTitle);
          console.log(`  - presignedUrl:`, sign.sign.presignedUrl);
          console.log(`  - objectKey:`, sign.sign.objectKey);
        });
      }
    }, 2000);
  },
  beforeDestroy() {
    this._isDestroyed = true;
    PresenceService.stop();
    if (this._beforeUnloadHandler) {
      window.removeEventListener("beforeunload", this._beforeUnloadHandler);
    }
  },
  methods: {
    showCO2Modal() {
      this.$bvModal.show("co2-modal");
    },
    handleBackButton() {
      let isLatest = this.$route.query.isLatest;
      this.$store.commit(
        DashboardConstants.COMMIT.setStatusEditable,
        isLatest == "true"
      );
    },
    navigateToDate(dateStr) {
      const siteId = this.$route.query.siteId;
      const period = this.$route.query.period;
      const targetDate = moment(dateStr);
      const objDate = {
        year: targetDate.format("YYYY"),
        month: targetDate.format("MM"),
        day: targetDate.format("DD"),
      };

      // 対象日付の日誌を取得して遷移
      getDiariesApi({
        siteId: siteId,
        year: objDate.year,
        month: parseInt(objDate.month),
        day: parseInt(objDate.day),
        period: period,
      }).then((response) => {
        const diaries = response.data.result;
        if (diaries && diaries.length > 0) {
          // 最新のリビジョンを取得
          const sorted = diaries.sort(
            (a, b) => (b.revision || 0) - (a.revision || 0)
          );
          const latestDiary = sorted[0];
          const previousDiary = sorted.length > 1 ? sorted[1] : sorted[0];

          const objDateTimestamp = targetDate.unix();
          this.$router.push({
            path: "/dashboard/",
            query: {
              diary: latestDiary.diaryId,
              diaryPrevious: previousDiary.diaryId,
              isLatest: "true",
              typeEdit: this.$route.query.typeEdit || "actual",
              siteId: siteId,
              objDate: objDateTimestamp,
              period: period,
            },
          });
        }
      }).catch((error) => {
        console.error("Failed to navigate to date:", error);
      });
    },
    goToPreviousDate() {
      if (this.previousDate) {
        this.navigateToDate(this.previousDate);
      }
    },
    goToNextDate() {
      if (this.nextDate) {
        this.navigateToDate(this.nextDate);
      }
    },
    goToToday() {
      const today = moment().format("YYYY-MM-DD");
      const dates = this.diaryDates;

      // 本日の日誌があればそこへ遷移
      if (dates.includes(today)) {
        this.navigateToDate(today);
      } else {
        // 本日の日誌がない場合は予定入力（空の新規画面）として遷移
        const siteId = this.$route.query.siteId;
        const period = this.$route.query.period;
        const todayMoment = moment();
        this.$router.push({
          path: "/dashboard/",
          query: {
            isLatest: "false",
            typeEdit: "budget",
            siteId: siteId,
            objDate: todayMoment.unix(),
            period: period,
          },
        });
      }
    },
    setDataHeader(path, value) {
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
        path: path,
        value: value,
      });
      path == "editor" && value != "" && (this.showEditorError = false);
    },
    setDataHeaderSigns(attr, order, value) {
      this.$store.commit(DashboardConstants.COMMIT.setDataHeaderSigns, {
        attr: attr,
        order: order,
        value: value,
      });
    },
    saveDiary() {
      this.isPostedDiary = true;
      const siteId = this.$route.query.siteId;
      const typeEdit = this.$route.query.typeEdit;
      const diaryId = this.$route.query.diary;
      const diaryIdPrevious = this.$route.query.diaryPrevious;
      const objDateTemp = this.$route.query.objDate;
      const period = this.$route.query.period;

      let diaryTemp =
        this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions];
      // validate
      const objValidate = this.validateDiary(diaryTemp);
      if (objValidate.status) {
        let diary = DashboardServices.serializerDiary(
          diaryTemp,
          siteId,
          typeEdit,
          false
        );
        postDiaryApi(diary).then((response) => {
          this.statusSaveDiary = response.data.success;
          this.$bvModal.show("bv-modal-mess");

          // 保存成功後に loadedOriginalRowIds を更新
          this.$store.commit(DashboardConstants.COMMIT.updateLoadedOriginalRowIds);

          const params = {
            isLatest: true,
            diaryId: diaryId,
            diaryIdPrevious: diaryIdPrevious,
            siteId: siteId,
            objDate: objDateTemp,
            period: period,
          };
          this.$router.replace({ query: params });
          this.handleBackButton();
        }).catch((error) => {
          if (error.response && error.response.status === 409) {
            // 楽観的ロック競合: 自分の追加分を特定してモーダル表示
            this.isPostedDiary = false;
            const loadedIds = this.$store.getters[DashboardConstants.GETTERS.getLoadedOriginalRowIds];
            const currentWorkRecords = this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions].workRecords || [];
            const localAdditions = DashboardServices.extractLocalAdditions(currentWorkRecords, loadedIds);
            this.conflictLocalAdditionsCount = localAdditions.length;
            if (localAdditions.length > 0) {
              this.conflictMessage = [
                '別のタブまたは他のユーザーが先に保存しました。',
                `自分が追加した作業内容（${localAdditions.length}件）を保持したまま最新データに統合して保存できます。`,
                '※ 既存レコードへの編集内容はサーバー側の最新版が優先されます。',
              ].join('\n');
            } else {
              this.conflictMessage = [
                '別のタブまたは他のユーザーが先に保存しました。',
                '自分の編集内容で上書き保存するか、最新データを読み込むか選択してください。',
              ].join('\n');
            }
            this.showConflictModal = true;
          } else {
            console.error("日誌の保存に失敗しました:", error);
            this.statusSaveDiary = false;
            this.isPostedDiary = false;
            this.$bvModal.show("bv-modal-mess");
          }
        });
      } else if (objValidate.mess == "meetingDateTimeNotNull") {
        this.statusSaveDiary = false;
        this.isPostedDiary = false;
        this.$bvModal.show("bv-modal-mess");
      } else if (objValidate.mess == "editorRequired") {
        this.showEditorError = true;
        this.isPostedDiary = false;
      }
    },
    /**
     * 競合時に自分の追加分をマージして再保存する
     * リトライ上限: 3回（毎回 GET → マージ → POST のサイクル）
     */
    async mergeAndResave(retryCount = 0) {
      const MAX_RETRIES = 3;
      // モーダルは閉じずにスピナー表示（UX改善）
      this.isMerging = true;

      const siteId = this.$route.query.siteId;
      const typeEdit = this.$route.query.typeEdit;
      const period = this.$route.query.period;
      const objDateTemp = moment.unix(this.$route.query.objDate);
      const objDate = {
        year: objDateTemp.format("YYYY"),
        month: objDateTemp.format("MM"),
        day: objDateTemp.format("DD"),
      };

      try {
        // 1. サーバーから最新データを取得
        const response = await getDiaryRevision(siteId, objDate, period);
        if (this._isDestroyed) return;

        const serverDiaries = response && response.data ? response.data.result : null;

        if (!Array.isArray(serverDiaries) || serverDiaries.length === 0) {
          this.isMerging = false;
          this.conflictMessage = '最新データの取得に失敗しました。時間をおいて再度お試しください。';
          return;
        }

        // 最新リビジョンのサーバーデータを取得
        const sortedDiaries = serverDiaries.sort((a, b) => (b.revision || 0) - (a.revision || 0));
        const latestServerDiary = sortedDiaries[0];

        // 2. 自分の追加分を特定（loadedOriginalRowIds はまだ更新していないので正確に判定できる）
        const loadedIds = this.$store.getters[DashboardConstants.GETTERS.getLoadedOriginalRowIds];
        const currentWorkRecords = this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions].workRecords || [];
        const localAdditions = DashboardServices.extractLocalAdditions(currentWorkRecords, loadedIds);

        // 3. マージ: サーバー最新の全データ + 自分の追加 workRecords
        this.$store.commit(DashboardConstants.COMMIT.mergeDiaryAfterConflict, {
          serverDiary: latestServerDiary,
          localAdditions: localAdditions,
        });

        // 4. マージ済みのデータで再保存
        const diaryTemp = this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions];
        const diary = DashboardServices.serializerDiary(diaryTemp, siteId, typeEdit, false);

        const saveResponse = await postDiaryApi(diary);
        if (this._isDestroyed) return;

        // 保存成功: loadedOriginalRowIds を更新（ここで初めて更新する）
        this.$store.commit(DashboardConstants.COMMIT.updateLoadedOriginalRowIds);

        this.isMerging = false;
        this.showConflictModal = false;
        this.statusSaveDiary = saveResponse.data.success;
        this.$bvModal.show("bv-modal-mess");

        const diaryId = this.$route.query.diary;
        const diaryIdPrevious = this.$route.query.diaryPrevious;
        const params = {
          isLatest: true,
          diaryId: diaryId,
          diaryIdPrevious: diaryIdPrevious,
          siteId: siteId,
          objDate: this.$route.query.objDate,
          period: period,
        };
        this.$router.replace({ query: params });
        this.handleBackButton();
      } catch (error) {
        if (this._isDestroyed) return;

        if (error.response && error.response.status === 409 && retryCount < MAX_RETRIES - 1) {
          // 再度競合: リトライ（loadedOriginalRowIds は未更新なので追加分の判定は正確）
          await this.mergeAndResave(retryCount + 1);
        } else {
          this.isMerging = false;
          this.isPostedDiary = false;
          if (error.response && error.response.status === 409) {
            this.conflictMessage = "保存が混み合っています。しばらく待ってから再度お試しください。";
          } else {
            console.error("マージ再保存に失敗しました:", error);
            this.showConflictModal = false;
            this.statusSaveDiary = false;
            this.$bvModal.show("bv-modal-mess");
          }
        }
      }
    },
    /**
     * 競合時に自分の編集内容で上書き保存する（追加分がないケース用）
     * サーバーから最新の revision だけ取得して、ローカルのデータをそのまま再送する
     */
    async forceResave(retryCount = 0) {
      const MAX_RETRIES = 3;
      this.isMerging = true;

      const siteId = this.$route.query.siteId;
      const typeEdit = this.$route.query.typeEdit;
      const period = this.$route.query.period;
      const objDateTemp = moment.unix(this.$route.query.objDate);
      const objDate = {
        year: objDateTemp.format("YYYY"),
        month: objDateTemp.format("MM"),
        day: objDateTemp.format("DD"),
      };

      try {
        // 1. サーバーから最新の revision を取得
        const response = await getDiaryRevision(siteId, objDate, period);
        if (this._isDestroyed) return;

        const serverDiaries = response && response.data ? response.data.result : null;

        if (!Array.isArray(serverDiaries) || serverDiaries.length === 0) {
          this.isMerging = false;
          this.conflictMessage = '最新データの取得に失敗しました。時間をおいて再度お試しください。';
          return;
        }

        const sortedDiaries = serverDiaries.sort((a, b) => (b.revision || 0) - (a.revision || 0));
        const latestRevision = sortedDiaries[0].revision || 0;

        // 2. ローカルの revision を最新に更新するだけ（データはそのまま）
        this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
          path: 'revision',
          value: latestRevision,
        });
        this.$store.state.dashboardRecords.currentRevision = latestRevision;

        // 3. ローカルのデータで再保存
        const diaryTemp = this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions];
        const diary = DashboardServices.serializerDiary(diaryTemp, siteId, typeEdit, false);

        const saveResponse = await postDiaryApi(diary);
        if (this._isDestroyed) return;

        this.$store.commit(DashboardConstants.COMMIT.updateLoadedOriginalRowIds);

        this.isMerging = false;
        this.showConflictModal = false;
        this.statusSaveDiary = saveResponse.data.success;
        this.$bvModal.show("bv-modal-mess");

        const diaryId = this.$route.query.diary;
        const diaryIdPrevious = this.$route.query.diaryPrevious;
        const params = {
          isLatest: true,
          diaryId: diaryId,
          diaryIdPrevious: diaryIdPrevious,
          siteId: siteId,
          objDate: this.$route.query.objDate,
          period: period,
        };
        this.$router.replace({ query: params });
        this.handleBackButton();
      } catch (error) {
        if (this._isDestroyed) return;

        if (error.response && error.response.status === 409 && retryCount < MAX_RETRIES - 1) {
          await this.forceResave(retryCount + 1);
        } else {
          this.isMerging = false;
          this.isPostedDiary = false;
          if (error.response && error.response.status === 409) {
            this.conflictMessage = "保存が混み合っています。しばらく待ってから再度お試しください。";
          } else {
            console.error("上書き保存に失敗しました:", error);
            this.showConflictModal = false;
            this.statusSaveDiary = false;
            this.$bvModal.show("bv-modal-mess");
          }
        }
      }
    },
    editorBannerName(editor) {
      const name = editor.userName || '不明なユーザー';
      if (editor.userSub === this.currentUserSub) {
        return `${name}(自分)`;
      }
      return name;
    },
    reloadDiary() {
      this.showConflictModal = false;
      this.isPostedDiary = false;
      // 現在のページをリロード
      this.$router.replace({
        query: {
          ...this.$route.query,
          isLatest: "true",
          typeEdit: this.$route.query.typeEdit,
        },
      });
      location.reload();
    },
    // calendar
    dTimeChange(event) {
      let value = event.date == false ? undefined : event.date;
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
        path: "meetingDateTime",
        value: value,
      });
    },
    validateDiary(diary) {
      //editor is null
      if (diary.editor == "") {
        return { status: false, mess: "editorRequired" };
      } else if (diary.meetingDateTime == undefined) {
        return { status: false, mess: "meetingDateTimeNotNull" };
      }
      return { status: true, mess: "" };
    },
    resetState() {
      this.$store.commit(DashboardConstants.COMMIT.resetState);
    },
    showSignatureModal(order, dataSignImage, signFor) {
      //set order
      this.$store.commit("dashboardRecords/setSignature", {
        order: order,
        dataImage: dataSignImage,
        signFor: signFor,
      });
      this.$bvModal.show("signature-modal");
    },
    changeMessModal(typeMess) {
      this.typeMess = typeMess;
    },
    isImageBaseURL(sign) {
      // HTTPSのURLとオブジェクトURL（blob:）とデータURL（data:）をサポート
      console.log("isImageBaseURL called with:", sign);

      // signがnullまたは空文字列の場合はfalseを返す
      if (!sign) return false;

      // presignedUrlが存在する場合は、それが画像URLとして扱う
      if (sign.presignedUrl) {
        console.log("isImageBaseURL: presignedUrl exists:", sign.presignedUrl);
        return true;
      }

      // objectKeyが存在する場合も画像として扱う
      if (sign.objectKey) {
        console.log("isImageBaseURL: objectKey exists:", sign.objectKey);
        return true;
      }

      // 文字列の場合の処理
      if (typeof sign === "string") {
        // 一般的なURL形式かどうかをチェック
        const urlPattern = /^(https?:\/\/|blob:|data:)/i;
        if (urlPattern.test(sign)) {
          console.log("isImageBaseURL: URL pattern matched:", sign);
          return true;
        }

        // 画像ファイル拡張子を持つかどうかをチェック
        const imageExtensions = [
          ".png",
          ".jpg",
          ".jpeg",
          ".gif",
          ".bmp",
          ".webp",
          ".svg",
        ];
        for (const ext of imageExtensions) {
          if (sign.toLowerCase().endsWith(ext)) {
            console.log("isImageBaseURL: image extension matched:", sign);
            return true;
          }
        }
      }

      console.log("isImageBaseURL returning false for:", sign);
      return false;
    },
    isSignatureText(sign) {
      // 署名がテキストかどうかを判断
      return sign && !this.isImageBaseURL(sign);
    },
    createObjectUrl(presignedUrl) {
      console.log(`createObjectUrl called with: ${presignedUrl}`);

      // presignedUrlがnullまたは空文字列の場合は空文字列を返す
      if (!presignedUrl) return "";

      // presignedUrlがオブジェクトの場合
      if (typeof presignedUrl === "object") {
        // presignedUrlプロパティがある場合はそれを使用
        if (presignedUrl.presignedUrl) {
          console.log(
            `createObjectUrl: using presignedUrl property: ${presignedUrl.presignedUrl}`
          );
          return presignedUrl.presignedUrl;
        }
        // objectKeyプロパティがある場合はそれを使用
        if (presignedUrl.objectKey) {
          console.log(
            `createObjectUrl: using objectKey property: ${presignedUrl.objectKey}`
          );
          return presignedUrl.objectKey;
        }
      }

      // 文字列の場合
      if (typeof presignedUrl === "string") {
        // 既にURLの形式になっている場合はそのまま返す
        const urlPattern = /^(https?:\/\/|blob:|data:)/i;
        if (urlPattern.test(presignedUrl)) {
          console.log(`createObjectUrl: valid URL format: ${presignedUrl}`);
          return presignedUrl;
        }

        // 画像ファイル拡張子を持つ場合
        const imageExtensions = [
          ".png",
          ".jpg",
          ".jpeg",
          ".gif",
          ".bmp",
          ".webp",
          ".svg",
        ];
        for (const ext of imageExtensions) {
          if (presignedUrl.toLowerCase().endsWith(ext)) {
            console.log(`createObjectUrl: image file: ${presignedUrl}`);
            return presignedUrl;
          }
        }
      }

      console.log(`createObjectUrl: returning as is: ${presignedUrl}`);
      return presignedUrl;
    },
    isInt($event) {
      isInt($event);
    },
    isFloat($event) {
      isFloat($event);
    },
    /**
     * PDF のタイトル・ファイル名に使う日付と時間帯の表記
     * @returns {{formattedDate: string, periodLabel: string}}
     */
    pdfDateLabels() {
      const objDateTemp = moment.unix(this.$route.query.objDate);
      const period = this.$route.query.period;
      return {
        formattedDate: objDateTemp.format("YYYY年MM月DD日"),
        periodLabel: this.$t("workImplementDate.option." + period),
      };
    },
    /**
     * PDF 用の日誌データを組み立てる（新旧の PDF 出力ボタンで共通、issue #995）
     * siteMetaData は含めない（呼び出し側で取得して付ける）。
     * @returns {Object} PDF 用の日誌データ
     */
    buildPdfPayload() {
      const { formattedDate, periodLabel } = this.pdfDateLabels();
      return buildDiaryPdfPayload(
        this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions],
        {
          title: `安全日誌 - ${formattedDate} ${periodLabel}`,
          createdAt: moment().format("YYYY年MM月DD日 HH:mm"),
          year: moment().format("YYYY"),
          latestEditAs:
            this.$store.getters[DashboardConstants.GETTERS.getLatestEditAs], // 編集モード情報
        }
      );
    },
    /**
     * PDFを生成する
     */
    generatePdf() {
      if (this.isAnyPdfGenerating) return;
      // PDF生成中フラグをセット
      this.isGeneratingPdf = true;

      // 生成されたPDFのURL。ダウンロードに失敗した際、
      // 手動で取得できるようエラートーストにリンクとして提示する
      let generatedPdfUrl = null;

      const siteId = this.$route.query.siteId;
      const { formattedDate, periodLabel } = this.pdfDateLabels();

      // PDF生成用のデータを作成
      const pdfData = this.buildPdfPayload();

      // サイトのメタ情報を取得してからPDFを生成
      getMetaDataSite(siteId)
        .then((response) => {
          const siteMetaData = response.data;
          console.log("サイトのメタ情報を取得しました:", siteMetaData);

          // サイトのメタ情報を含めてPDF生成APIを呼び出す
          return generatePdfFromDiary(pdfData, siteMetaData);
        })
        .then((response) => {
          // PDF生成成功
          console.log("PDF generated successfully:", response);

          // PDFのURLを取得（presigned_urlが優先）
          const pdfUrl = response.pdf_url;

          if (!pdfUrl) {
            // エラーメッセージを表示
            this.$bvToast.toast("PDFのURLが取得できませんでした", {
              title: "PDF生成エラー",
              variant: "danger",
              solid: true,
            });
            return;
          }

          generatedPdfUrl = pdfUrl;

          // PDFをダウンロードする
          // window.open() はPDF生成待ちの間にユーザー操作の有効期間が切れ、
          // ポップアップブロックで無言failするため使用しない（issue #959）
          const pdfFileName = `安全日誌_${formattedDate}_${periodLabel}.pdf`;

          return downloadFileFromUrl(pdfUrl, pdfFileName).then(() => {
            // 成功メッセージを表示
            this.$bvToast.toast("PDFが正常に生成されました", {
              title: "PDF生成完了",
              variant: "success",
              solid: true,
            });
          });
        })
        .catch((error) => {
          // PDF生成またはダウンロードに失敗
          console.error("Failed to generate PDF:", error);

          // 生成は成功しダウンロードだけ失敗した場合は、
          // 「生成に失敗」と表示すると原因の切り分けを誤らせるため区別する。
          // このケースではPDFはS3に存在するので、手動で取得できるリンクを添える。
          // （トースト内リンクのクリックはユーザー操作なのでブロックされない）
          if (error instanceof DownloadError && generatedPdfUrl) {
            const h = this.$createElement;
            const message = h("div", [
              h("p", { class: "mb-1" }, "PDFのダウンロードに失敗しました。"),
              h(
                "a",
                {
                  attrs: {
                    href: generatedPdfUrl,
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                },
                "こちらからPDFを開く"
              ),
            ]);
            this.$bvToast.toast(message, {
              title: "PDFダウンロードエラー",
              variant: "danger",
              solid: true,
              // リンクを押す時間を確保するため自動で閉じない
              noAutoHide: true,
            });
            return;
          }

          // エラーメッセージを表示
          this.$bvToast.toast("PDFの生成に失敗しました", {
            title: "PDF生成エラー",
            variant: "danger",
            solid: true,
          });
        })
        .finally(() => {
          // PDF生成中フラグをリセット
          this.isGeneratingPdf = false;
        });
    },
    /**
     * PDFを生成する（新レイアウト・試行中。backend の rust-pdf、issue #995）
     *
     * 既存の generatePdf（pdf-api）と並行運用する。
     * 応答の base64 を Blob にして <a download> で保存させる（ポップアップブロック対策、issue #959）。
     * ページ割りは rust-pdf が行うため totalConsumedRowLength は送らない。
     */
    generatePdfV2() {
      if (this.isAnyPdfGenerating) return;
      this.isGeneratingPdfV2 = true;

      const siteId = this.$route.query.siteId;
      let pdfFileName;

      // データの組み立てで例外が出ても catch・finally を通す
      // （生成中フラグが戻らないと、既存のボタンまで押せなくなるため）
      Promise.resolve()
        .then(() => {
          const { formattedDate, periodLabel } = this.pdfDateLabels();
          // お客様が新旧の PDF を見分けられるよう、ファイル名の末尾に「_新レイアウト」を付ける
          pdfFileName = sanitizeFileName(
            `安全日誌_${formattedDate}_${periodLabel}_新レイアウト.pdf`
          );
          const pdfData = this.buildPdfPayload();
          return getMetaDataSite(siteId).then((response) =>
            generateDiaryPdf({ ...pdfData, siteMetaData: response.data })
          );
        })
        .then((response) => {
          const pdfBase64 = response.data && response.data.pdfData;
          if (!pdfBase64) {
            // 200 で PDF が空なのは生成側の問題なので、生成の失敗として扱う
            throw new Error("PDFのデータが空です");
          }
          // base64 の変換に失敗した場合は DownloadError になる
          const blob = base64ToBlob(pdfBase64, "application/pdf");
          downloadBlob(blob, pdfFileName);
          this.$bvToast.toast("PDFが正常に生成されました（新レイアウト）", {
            title: "PDF生成完了",
            variant: "success",
            solid: true,
          });
        })
        .catch((error) => {
          console.error("Failed to generate PDF (new layout):", error);
          const isDownloadError = error instanceof DownloadError;
          this.$bvToast.toast(
            isDownloadError
              ? "PDFのダウンロードに失敗しました（新レイアウト）"
              : "PDFの生成に失敗しました（新レイアウト）",
            {
              title: isDownloadError ? "PDFダウンロードエラー" : "PDF生成エラー",
              variant: "danger",
              solid: true,
            }
          );
        })
        .finally(() => {
          this.isGeneratingPdfV2 = false;
        });
    },
  },
  computed: {
    loggedInUserName() {
      return this.$store.getters[DiaryListConstants.GETTERS.getName];
    },
    getDataHeader() {
      return this.$store.getters[DashboardConstants.GETTERS.getDataHeader];
    },
    meetingDateTime: {
      get: function () {
        return this.$store.getters[DashboardConstants.GETTERS.getDataHeader]
          .meetingDateTime;
      },
    },
    meetingDateTimeDisabled() {
      // 予定入力(budget)の場合は編集可能、実施入力(actual)の場合は予定入力で保存した値を表示するため編集不可
      const typeEdit = this.$route.query.typeEdit;
      if (typeEdit === "actual") {
        return true;
      }
      return this.statusEditable;
    },
    getSigns() {
      return this.$store.getters[DashboardConstants.GETTERS.getSignRecords];
    },
    statusEditable() {
      return this.$store.getters[DashboardConstants.GETTERS.getStatusEditable];
    },
    linkBackButton() {
      const siteId = this.$route.query.siteId;
      const objDateTemp = this.$route.query.objDate;
      const period = this.$route.query.period;
      return `/?siteId=${siteId}&period=${period}&objDate=${objDateTemp}`;
    },
    showLoading() {
      console.log(this.isPostedDiary);
      if (this.isPostedDiary) return false;
      if (this.$route.query.diary) {
        // getDiaryRevisions が取得できない原因の確認
        console.info(
          "getDiaryRevisions:",
          this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions]
        );
        console.log(
          this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions]
            .revision
        );
        return this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions]
          .revision
          ? false
          : true;
      } else {
        if (
          this.$store.getters[DashboardConstants.GETTERS.getDiaries].length == 0
        )
          return false;

        return this.$store.getters[
          DashboardConstants.GETTERS.getInitRevisionsState
        ].revision
          ? true
          : false;
      }
    },
    generateParamsAfterPost() {
      const siteId = this.$route.query.siteId;
      const objDateTemp = this.$route.query.objDate;
      const period = this.$route.query.period;
      return {
        siteId: siteId,
        objDate: objDateTemp,
        period: period,
      };
    },
    isNullCo2InSiteOutSiteWork() {
      const inSiteWork =
        this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions]
          .co2InSiteWork;
      const outSiteWork =
        this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions]
          .co2OutSiteWork;
      return inSiteWork.length + outSiteWork.length == 0;
    },
    isViewerUser() {
      return this.siteUserRole === 'VIEWER';
    },
    // 新旧どちらかの PDF を生成中か（生成中は両方のボタンを押せなくする、issue #995）
    isAnyPdfGenerating() {
      return this.isGeneratingPdf || this.isGeneratingPdfV2;
    },
    previousDate() {
      return this.$store.getters[DashboardConstants.GETTERS.getPreviousDate];
    },
    nextDate() {
      return this.$store.getters[DashboardConstants.GETTERS.getNextDate];
    },
    diaryDates() {
      return this.$store.getters[DashboardConstants.GETTERS.getDiaryDates];
    },
  },
  watch: {
    "$route.query": {
      handler(newQuery, oldQuery) {
        // 同一コンポーネント内での日付ナビゲーション時にデータを再取得
        if (
          newQuery.objDate !== oldQuery.objDate ||
          newQuery.diary !== oldQuery.diary
        ) {
          const diaryId = newQuery.diary;
          const diaryIdPrevious = newQuery.diaryPrevious;
          const siteId = newQuery.siteId;
          const period = newQuery.period;
          const objDateTemp = moment.unix(newQuery.objDate);
          const objDate = {
            year: objDateTemp.format("YYYY"),
            month: objDateTemp.format("MM"),
            day: objDateTemp.format("DD"),
          };
          const typeEdit = newQuery.typeEdit;

          this.$store.dispatch(
            DashboardConstants.DISPATCH.getDiaryRevisionRecords,
            {
              siteId: siteId,
              objDate: objDate,
              diaryId: diaryId,
              diaryIdPrevious: diaryIdPrevious,
              typeEdit: typeEdit,
              period: period,
            }
          );
          this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
            path: "diaryPeriod",
            value: period,
          });
          this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
            path: "diaryDate",
            value: objDateTemp,
          });
          this.handleBackButton();
        }

        // 日誌のコンテキストが変わった場合、プレゼンスを再開
        if (
          newQuery.siteId !== oldQuery.siteId ||
          newQuery.objDate !== oldQuery.objDate ||
          newQuery.period !== oldQuery.period
        ) {
          const siteId = newQuery.siteId;
          const objDateTemp = moment.unix(newQuery.objDate);
          const diaryDateStr = objDateTemp.format("YYYY-MM-DD");
          const period = newQuery.period;
          const userName = this.$store.state.dashboardRecords.loggedInUserName;

          // 古いセッションを停止して新しいセッションを開始
          PresenceService.stop();
          this.activeEditors = [];
          PresenceService.start(siteId, diaryDateStr, period, userName);
        }
      },
      deep: true,
    },
    loggedInUserName(userName) {
      if (!userName) return;
      this.$store.commit("dashboardRecords/setLoggedInUserName", userName);
      if (!this.getDataHeader.meta.editor) {
        this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
          path: "editor",
          value: userName,
        });
      }
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
        path: "responsibleOfSafe",
        value: userName,
      });
    },
  },
  filters: {
    formatDataTimeJP(dataTime) {
      if (moment(dataTime)) {
        return moment(dataTime).locale("ja").format("LLLL", "jp");
      }
    },
  },
};
